import { AspectContainer } from '../../AspectContainer';
import { BuildingViewerBuildingData } from '../../../../Content';
import { PickableRegion } from './PickableRegion';

export interface Props {
  src: string;
  buildings: BuildingViewerBuildingData[];
  activeBuilding: BuildingViewerBuildingData | null;
  onBuildingClick: (building: BuildingViewerBuildingData) => void;
}

export const BuildingPicker: React.FC<Props> = (props) => {
  return (
    <AspectContainer aspect={0.5625}>
      <div
        style={{
          backgroundImage: `url("${props.src}")`,
          backgroundSize: 'cover',
          height: '100%',
          position: 'relative',
        }}
      >
        {/* Building Region */}
        {props.buildings.map((building) => (
          <PickableRegion
            key={building.id}
            region={building.region}
            isActive={building === props.activeBuilding}
            onClick={() => props.onBuildingClick(building)}
          />
        ))}
      </div>
    </AspectContainer>
  );
};
